import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import GoogleMap from './GoogleMap';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/contact.js';
import pageData from '../../data/pages/contact.json';
import { sendContactEmail } from '../../helper/emailService';

function Contact() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [lastSubmitTime, setLastSubmitTime] = useState(0);

    const Datas = pageData;

    const validateForm = () => {
        const newErrors = {};

        if (!name.trim()) {
            newErrors.name = "Name can't be blank";
        } else if (name.trim().length > 100) {
            newErrors.name = "Name cannot exceed 100 characters";
        }

        if (!email.trim()) {
            newErrors.email = "Email can't be blank";
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim())) {
            newErrors.email = "Not a valid email";
        } else if (email.trim().length > 100) {
            newErrors.email = "Email cannot exceed 100 characters";
        }

        if (!phone.trim()) {
            newErrors.phone = "Phone number can't be blank";
        } else if (!/^\d+$/.test(phone.trim())) {
            newErrors.phone = "Phone number must contain digits only";
        } else if (phone.trim().length < 11) {
            newErrors.phone = "Phone number must be at least 11 digits";
        } else if (phone.trim().length > 15) {
            newErrors.phone = "Phone number cannot exceed 15 digits";
        }

        if (!subject.trim()) {
            newErrors.subject = "Subject can't be blank";
        } else if (subject.trim().length > 150) {
            newErrors.subject = "Subject cannot exceed 150 characters";
        }

        if (!message.trim()) {
            newErrors.message = "Message can't be blank";
        } else if (message.trim().length < 5) {
            newErrors.message = "Message must be at least 5 characters";
        } else if (message.trim().length > 2000) {
            newErrors.message = "Message cannot exceed 2000 characters";
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return;

        // Rate limiting: 10 second cooldown between requests
        const now = Date.now();
        if (now - lastSubmitTime < 10000) {
            setErrorMsg("Please wait a few seconds before submitting another request.");
            return;
        }

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSuccessMsg('');
            setErrorMsg('');
            return;
        }

        setErrors({});
        setSuccessMsg('');
        setErrorMsg('');
        setIsSubmitting(true);

        try {
            await sendContactEmail({ name, email, phone, subject, message });
            setSuccessMsg("Your message has been sent successfully! One of our education counselors will get back to you soon.");
            setName('');
            setEmail('');
            setPhone('');
            setSubject('');
            setMessage('');
            setLastSubmitTime(Date.now());
        } catch (err) {
            setErrorMsg("Failed to send your message. Please try again later or contact us directly at info@globalabroadbd.com.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcrumb */}
                <BreadcrumbBox title="Contact Us" bgImage="globalAbroad/contact_banner.png" />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                        <Row>
                            <Col md="4">
                                <div className="contact-box-title">
                                    <h4>{Datas.contactInfoTitle}</h4>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-map-marker"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{Datas.locationTitle}</h5>
                                        <p>{Datas.location}</p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{Datas.emailTitle}</h5>
                                        <p>
                                            {Datas.emails.map((emailItem, index) => (
                                                <React.Fragment key={index}>
                                                    {emailItem}{index < Datas.emails.length - 1 ? <br /> : null}
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>
                                </div>
                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>{Datas.phoneTitle}</h5>
                                        <p>
                                            {Datas.phones.map((phoneItem, index) => (
                                                <React.Fragment key={index}>
                                                    {phoneItem}{index < Datas.phones.length - 1 ? <br /> : null}
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>
                                </div>
                                <div className="contact-social">
                                    <ul className="social list-unstyled list-inline">
                                        {Datas.socialLinks.map((social, index) => (
                                            <li className="list-inline-item" key={index}>
                                                <a href={social.link} target="_blank" rel="noopener noreferrer"><i className={social.iconClass}></i></a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Col>
                            <Col md="8">
                                <div className="contact-form">
                                    <div className="form-title">
                                        <h4>{Datas.formTitle}</h4>
                                    </div>
                                    <div className="form-box">
                                        {successMsg && (
                                            <div style={{ color: '#ffffff', backgroundColor: '#28a745', padding: '12px', borderRadius: '5px', marginBottom: '20px', fontWeight: '500', textAlign: 'center' }}>
                                                {successMsg}
                                            </div>
                                        )}
                                        {errorMsg && (
                                            <div style={{ color: '#ffffff', backgroundColor: '#dc3545', padding: '12px', borderRadius: '5px', marginBottom: '20px', fontWeight: '500', textAlign: 'center' }}>
                                                {errorMsg}
                                            </div>
                                        )}
                                        <form id="form_contact" className="form" onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md="12">
                                                    <p className={`form-control ${errors.name ? 'error' : name ? 'success' : ''}`}>
                                                        <input 
                                                            type="text" 
                                                            placeholder="Full Name" 
                                                            id="contact_name"
                                                            value={name}
                                                            onChange={(e) => setName(e.target.value)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <span className="contact_input-msg">{errors.name}</span>
                                                    </p>
                                                </Col>
                                                <Col md="6">
                                                    <p className={`form-control ${errors.email ? 'error' : email ? 'success' : ''}`}>
                                                        <input 
                                                            type="email" 
                                                            placeholder="Email Address" 
                                                            id="contact_email" 
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <span className="contact_input-msg">{errors.email}</span>
                                                    </p>
                                                </Col>
                                                <Col md="6">
                                                    <p className={`form-control ${errors.phone ? 'error' : phone ? 'success' : ''}`}>
                                                        <input 
                                                            type="text" 
                                                            placeholder="Phone Number" 
                                                            id="contact_phone" 
                                                            value={phone}
                                                            onChange={(e) => setPhone(e.target.value)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <span className="contact_input-msg">{errors.phone}</span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className={`form-control ${errors.subject ? 'error' : subject ? 'success' : ''}`}>
                                                        <input 
                                                            type="text" 
                                                            placeholder="Subject" 
                                                            id="contact_subject" 
                                                            value={subject}
                                                            onChange={(e) => setSubject(e.target.value)}
                                                            disabled={isSubmitting}
                                                        />
                                                        <span className="contact_input-msg">{errors.subject}</span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <p className={`form-control ${errors.message ? 'error' : message ? 'success' : ''}`}>
                                                        <textarea 
                                                            name="message" 
                                                            id="contact_message" 
                                                            placeholder="Enter Message"
                                                            value={message}
                                                            onChange={(e) => setMessage(e.target.value.replace(/<[^>]*>?/gm, ''))}
                                                            disabled={isSubmitting}
                                                        ></textarea>
                                                        <span className="contact_input-msg">{errors.message}</span>
                                                    </p>
                                                </Col>
                                                <Col md="12">
                                                    <button type="submit" disabled={isSubmitting}>
                                                        {isSubmitting ? "Sending..." : "Send Message"}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Google Map */}
                    <GoogleMap />
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    );
}

export default Contact;